import { cn } from '@/shared/utils';

import { getCartPriceParts } from '../lib/cart-formatters';
import type { CartCurrency } from '../types/cart';

interface CartPriceTextProps {
  amount: number;
  currency: CartCurrency;
  size?: 'item' | 'total';
}

export const CartPriceText = ({ amount, currency, size = 'item' }: CartPriceTextProps) => {
  const priceParts = getCartPriceParts(amount, currency);

  return (
    <span className="text-adipa-text-primary inline-flex items-baseline whitespace-nowrap leading-none">
      <span
        className={cn(
          'mr-1 font-medium leading-none',
          size === 'total' ? 'text-sm' : 'text-adipa-cart-currency',
        )}
      >
        {priceParts.currencyLabel}
      </span>
      <span
        className={cn(
          'font-bold leading-none',
          size === 'total' ? 'text-2xl' : 'text-adipa-cart-price',
        )}
      >
        {priceParts.amountLabel}
      </span>
    </span>
  );
};
